import { css } from 'styled-components';

export const ListItemCSS = css`
  background-color: #ffffff;
  width: 100%;
  padding: 1rem;
  border-bottom: 1px solid #eeeeee;
`;

export const ListIemUpdatingCSS = css`
  ${(props) =>
    props.isUpdating &&
    css`
      & * {
        pointer-events: none;
      }
      opacity: 0.7 !important;
      background: #fafafa;
    `};
`;
